import { Flex, Form, Radio } from 'antd'
import { FormattedMessage } from 'react-intl'
import { ICryptoCurrency } from '../../api/types'
import { FiatProvider } from '../../types'
import { formKeys } from '../DonationForm/constants'
import Crypto from './Crypto'
import Fiat from './Fiat'
import { lang } from './lang'
import Label from '@/shared/components/Label'
import { PaymentType } from '@/pages/Donation/api/streamer/types.ts'

type Props = {
  cryptoCurrencies: ICryptoCurrency[]
  fiatProviders?: FiatProvider[]
  isProvidersLoading?: boolean
  isCryptoOptionsLoading: boolean
  onSetCryptoAsset: (asset: ICryptoCurrency | null, networkCode?: string) => void
  onPaymentTypeChange: (value: PaymentType) => void
}

export default function PaymentTypes({
  cryptoCurrencies,
  fiatProviders,
  onSetCryptoAsset,
  isProvidersLoading,
  onPaymentTypeChange,
  isCryptoOptionsLoading,
}: Props) {
  return (
    <Flex vertical gap={4}>
      <Label>
        <FormattedMessage {...lang.paymentTitle} />
      </Label>
      <Form.Item name={formKeys.paymentType} noStyle>
        <Radio.Group onChange={e => onPaymentTypeChange(e.target.value)}>
          <Flex vertical gap={12}>
            <Crypto
              currencies={cryptoCurrencies}
              onSelectCryptoAsset={onSetCryptoAsset}
              isOptionsLoading={isCryptoOptionsLoading}
            />
            <Fiat options={fiatProviders} isOptionsLoading={isProvidersLoading} />
          </Flex>
        </Radio.Group>
      </Form.Item>
    </Flex>
  )
}
